/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MandateAssignment } from './mandateAssignment';

export type CourseModuleSettingsOutputMandates = MandateAssignment | null;
